export default __webpack_public_path__ + "static/media/33_photo.f4f7256d.jpg";